<template>
  <v-card
  id="elementId"
  :class="`${elementClass} ${fillHeight ? 'fill-height' : ''} ${$vuetify.breakpoint.xs ? '' : 'px-1'}`"
  :outlined="outlined"
  :flat="flat"
  :style="propStyle">
    <v-card-title class="subtitle-1 pb-3" v-if="title">
      <v-row no-gutters>
        <v-col>
          <slot name="title"/>
          <span>
            {{ title }}
          </span>
          <slot name="title.adjacent"/>
        </v-col>
        <v-col cols="auto">
          <slot name="title.append"/>
        </v-col>
        <v-col cols="auto" v-if="collapsible">
          <Icon
          :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
          :small="false"
          margin=""
          @icon-clicked="expanded = !expanded"/>
        </v-col>
      </v-row>
    </v-card-title>
    <v-expand-transition>
      <v-card-text class="pb-1" v-show="!contentHidden">
        <slot/>
      </v-card-text>
    </v-expand-transition>
    <v-card-actions v-show="!contentHidden">
      <slot name="actions"/>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'DetailCard',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    elementId: {
      type: String,
      required: false,
      default: undefined
    },
    elementClass: {
      type: String,
      required: false,
      default: undefined
    },
    title: {
      type: String,
      required: false,
      default: undefined
    },
    propStyle: {
      type: Object,
      required: false,
      default: undefined
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    fillHeight: {
      type: Boolean,
      default: true
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    expanded: false
  }),

  computed: {
    outlined () {
      return !this.flat
    },

    contentHidden () {
      return this.collapsible && !this.expanded
    }
  }
}
</script>
